import {ApplicationState} from "framework/applicationState";
import {dateToString} from "tools/dateTimeUtils";
import {GenerateLegendStringArgs} from "areas/metrics/components/MetricLegendSelect/utils/generateLegendString";

const mapping : Record<string, (args: GenerateLegendStringArgs) => string> = {
	'<Account>': (args) => args.data.accountName,
	'<Agent>': (args) => args.data.agentName,
	'<Asset name>': (args) => args.data.assetName,
	'<Asset>': (args) => args.data.assetName,
	'<Category>': (args) => args.data.identifier + ' ' + args.data.categoryNode,
	'<CategoryNode>': (args) => args.data.categoryNode,
	'<CategoryPath>': (args) => args.data.categoryPath,
	'<Instance>': (args) => args.data.instanceName ?? args.data.name,
	'<KPI account>': (args) => args.data.kpiAccountName,
	'<Metric name>': (args) => args.data.categoryNode,
	'<MetricId>': (args) => args.data.metricId,
	'<MetricName>': (args) => args.data.metricName,
	'<MetricType>': (args) => args.data.metricType,
	'<MonitorType>': (args) => args.data.monitorTypeText,
	'<Monitorname>': (args) => args.data.monitorName,
	'<Name>': (args) => args.data.categoryNode,
	'<Profile>': (args) => args.data.profileText,
	'<Qualifier>': (args) => args.data.qualifierDescription,
	'<RegistryIdentifier>': (args) => args.data.registryIdentifier,
	'<RegistryOwnerId>': (args) => args.data.registryOwnerId,
	'<RegistryType>': (args) => args.data.registryType,
	'<RuleType>': (args) => args.data.typeText,
	'<SampleRate>': (args) => args.data.sampleRateText,
	'<Service>': (args) => args.data.serviceName,
	'<Serviceelement>': (args) => args.data.elementName,
	'<Servicequalifier>': (args) => args.data.name,
	'<Source>': (args) => args.data.sourceName,
	'<Subsystem>': (args) => args.data.groupName,
	'<Time>': (args) => dateToString(args.x, "datetime", '', args.extra?.timezone),
	'<Timezone>': (args) => args.extra?.timezone ?? ApplicationState.timezone,
	'<Type>': (args) => args.data.registryType,
	'<Unit>': (args) => args.data.unitTypeSymbol,
	'<Value and unit>': (args: GenerateLegendStringArgs) => `${args.y} ${args.data.customUnit ?? args.data.unitTypeSymbol}`,
};

export type GenerateLegendArrayArgs = {
	template: string[]
	data: any
	extra?: {
		timezone: string
	}
	y?: string | number
	x?: Date
}

export function generateLegendArray(args: GenerateLegendArrayArgs) {
	if (!args.template || args.template.length == 0) {
		return [];
	}

	const pieces: string[] = [];
	args.template.forEach(key => {
		if (!mapping[key] && !key.startsWith('<')) {
			pieces.push(key);
		} else if (mapping[key]) {
			pieces.push(mapping[key](args))
		}
	})

	return pieces;
}
